import classes from './MealsSummary.module.css'

const MealsSummary = () => {
    return (
      <section className={classes.summary}> 
        <h2>Good Sushi for Good People</h2>
        <p>The art of fusion sushi</p>
        <p>Enjoy ordering our new items</p>
      </section>
    );
};

export default MealsSummary;